import { isValid, parseISO } from 'date-fns';

export const validateIsoDateString = (dateString: string | undefined | null): boolean => {
  if (!dateString) return false;
  const pasredDate = parseISO(dateString);
  return isValid(pasredDate);
};
